import { render, staticRenderFns } from "./DocumentUploader.vue?vue&type=template&id=00da6290"
import script from "./DocumentUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentUploader.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports